__turbopack_context__.v({
  "banner": "W5q9Xa_banner",
  "banner--context-flex-grid": "W5q9Xa_banner--context-flex-grid",
  "banner__button": "W5q9Xa_banner__button",
  "banner__buttons": "W5q9Xa_banner__buttons",
  "banner__headline": "W5q9Xa_banner__headline",
  "banner__headline-wrapper": "W5q9Xa_banner__headline-wrapper",
  "banner__link": "W5q9Xa_banner__link",
  "banner__sub-headline": "W5q9Xa_banner__sub-headline",
});
